import {
    RESET_EMAIL_OPEN_MODAL,
    RESET_EMAIL_CLOSE_MODAL,
    RESET_EMAIL_REQUEST,
    RESET_EMAIL_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    entity: null,
    callback: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case RESET_EMAIL_OPEN_MODAL:
            return { ...state, openModal: true, entity: action.payload.entity, callback: action.payload.callback }

        case RESET_EMAIL_CLOSE_MODAL:
            return { ...state, openModal: false }

        case RESET_EMAIL_REQUEST:
            return { ...state, loading: true }

        case RESET_EMAIL_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "RESET_EMAIL"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};